module.exports = __webpack_public_path__ + "static/media/mobile_tracking.255e2890.svg";